const DELIMITER = ';'

export function createCSV(dataset, filename){
    let csvContent = "data:text/csv;charset=utf-8," 
    + dataset.map(e => e.join(DELIMITER)).join("\n");

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename+".csv");
    document.body.appendChild(link); // Required for FF

    link.click();
}

export default createCSV;